/**
 *
 *  Initialize  search box and autocomplete
 *
 */
import openHelpCenterContent from './open-helpcenter-content';

export default function (sdk, sdkConfig) {
  if (document.querySelector('#searchbox') && document.querySelector('#autocompleter')) {
    console.log('search init');
    let searchBox = sdk.component('searchBox', '#searchbox', {
      labels: {
        SEARCH_BOX_PLACEHOLDER: 'Comment faire un devis, therminox, règlementation dévoiement, sortie de toit...',
      },
    });
    const autocompleter = sdk.component('autocompleter', '#autocompleter', {});
    autocompleter.linkToSearchBox(searchBox);
    autocompleter.$on('autocompleterClick', contentId => openHelpCenterContent(sdk.client, sdkConfig, contentId));

    // When performing search, redirect to result page with query in the URL parameters
    searchBox.$on('query', function (searchQuery) {
      window.open(`${sdkConfig.searchResultsURL}?query=${searchQuery}`, '_self');
    });

    searchBox.untilReady.then(() => {
      let searchBars = document.querySelectorAll('.inbenta-km__search__form .inbenta-km-input');
      for(let i = 0; i < searchBars.length; i++) {
        searchBars[i].setAttribute('maxlength', '100');
      }
    });

    return searchBox
  }
}


// WEBPACK FOOTER //
// ./src/scripts/helpers/search-init.js